import { gql } from '@apollo/client';

export const GRAPHQL_BUSCAR_USUARIO_LOGS = gql`
    query BuscarUsuarioLogs($filter: UsuarioLogFilter) {
        usuarioLogs(filter: $filter) {
            data {
                id
                usuarioId
                usuarioNomeCompleto
                usuarioEmail
                acao
                descricao
                rota
                metodo
                status
                dataRegistro
                tempoExecucaoMs
            }
            hasNextPage
        }
    }
`;

export const GRAPHQL_BUSCAR_USUARIO_LOG_DETALHE = gql`
    query BuscarUsuarioLogDetalhe($id: ID!) {
        usuarioLogById(id: $id) {
            id
            usuarioId
            usuarioNomeCompleto
            usuarioEmail
            acao
            descricao
            rota
            metodo
            status
            dataRegistro
            tempoExecucaoMs
            erroMensagem
            ipAddress
            userAgent
            parametros
            resultados
        }
    }
`;
